import { render, staticRenderFns } from "./InfoMsg.vue?vue&type=template&id=56fa92b0&"
import script from "./InfoMsg.vue?vue&type=script&lang=js&"
export * from "./InfoMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports